import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useReturnCard = (returnOrder) => {
  return useQuery({
    queryKey: ["returnCardState", returnOrder],
    queryFn: async () =>
      callApi({
        path: "completedreturnordercard",
        command: "",
        data: JSON.stringify({
          data: { filter: { noFilter: returnOrder } },
        }),
      }),
  });
};
